import { render, staticRenderFns } from "./SearchBoxProjeto.vue?vue&type=template&id=f4e038bc&scoped=true"
import script from "./SearchBoxProjeto.vue?vue&type=script&lang=js"
export * from "./SearchBoxProjeto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4e038bc",
  null
  
)

export default component.exports